import React, {useContext, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { startModifyForm } from '../../../redux/actions/form';
import { TitleBlock } from '../../../components/blocks/TitleBlock';
import { ProgressBlock } from '../../../components/blocks/ProgressBlock';
import { Radiolist } from '../../../components/inputs/Radiolist';
import { ActionBar } from '../../../components/toolbars/ActionBar';
import { FORM_TYPES, getStepData } from '../../../enums/Steps';
import { useLanguage } from "../../../hooks/useLanguage";
import { Ethnicities } from '../../../enums/Ethnicities';


export const JourneyEthnicityForm = (props) => {
  const form = useSelector((state) => state.form[0]);
  const dispatch = useDispatch();
  const { t } = useLanguage()

  const step = 'ethnicity';
  const { nextStep, prevStep, currentStepIndicator } = getStepData(step, FORM_TYPES.journey, t);

  const handleEthnicitySelect = (ethnicity) => {
    dispatch(startModifyForm({ ...form, patientEthnicity: ethnicity }));
  };

  const [validation, setValidation] = useState(false);
  const validate = () => {
    setValidation(true);
  };

  const getTranslatedEthnicities = () =>
      Ethnicities.map(option => ({
        ...option,
        name: t(option.value)
  }));

  const translatedEthnicities= getTranslatedEthnicities();

    const actionBarCopy = t('4_of_5');
    // const translatedActionBarCopy = actionBarCopy === '4_of_5' ? "4 of 5" : actionBarCopy

  return (
    <React.Fragment>
      <ProgressBlock value1={currentStepIndicator} value2={0} />
      <div className="inner-form-container">
        <TitleBlock copy={t('journey_ethnicity_question')} />
        <br />
        <Radiolist
          options={translatedEthnicities}
          selected={form.patientEthnicity}
          isRows={true}
          handleSelect={handleEthnicitySelect}
          validation={validation}
        />
      </div>
      <ActionBar
        prevState={prevStep}
        handleValidation={validate}
        copy={actionBarCopy}
        nextState={form.patientEthnicity ? nextStep : ''}
      />
    </React.Fragment>
  );
};
